import { render, staticRenderFns } from "./Lbs.vue?vue&type=template&id=bc84aeb0&scoped=true&"
import script from "./Lbs.vue?vue&type=script&lang=js&"
export * from "./Lbs.vue?vue&type=script&lang=js&"
import style0 from "./Lbs.vue?vue&type=style&index=0&id=bc84aeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc84aeb0",
  null
  
)

export default component.exports